import React from 'react'

import PropTypes from 'prop-types'

import { useModalDialog } from '@termly-web/common'

import Styles from './styles.scss'


export default function ModalDialog({ ariaLabel, children, handleCancel }) {
  const {
    closedby,
    dialogRef,
    onCancel,
    onClose,
  } = useModalDialog({ handleCancel })

  return (
    <dialog
      aria-label={ ariaLabel }
      className={ Styles.root }
      closedby={ closedby }
      onCancel={ onCancel }
      onClose={ onClose }
      ref={ dialogRef }
    >
      { children }
    </dialog>
  )
}

ModalDialog.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  handleCancel: PropTypes.func,
}
